"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
 mutation updateOrgEmailWebhook($email: String!) {
  updateOrgEmailWebhook(email: $email)
}
`;
exports.default = mutation;
//# sourceMappingURL=updateOrgEmailWebhook.mutation.js.map